export const languagesMixin = {
  methods: {
    getEnglish: function () {
      return { code: 'EN', name: 'English' }
    },
    getLanguages: function () {
      return [
        { code: 'af', name: 'Afrikaans' },
        { code: 'sq', name: 'Albanian' },
        { code: 'ar', name: 'Arabic' },
        { code: 'az', name: 'Azerbaijani' },
        { code: 'bn', name: 'Bengali' },
        { code: 'bg', name: 'Bulgarian' },
        { code: 'ca', name: 'Catalan' },
        { code: 'zh-cn', name: 'Chinese (CHN)' },
        { code: 'zh-hk', name: 'Chinese (HKG)' },
        { code: 'zh-tw', name: 'Chinese (TAI)' },
        { code: 'hr', name: 'Croatian' },
        { code: 'cs', name: 'Czech' },
        { code: 'da', name: 'Danish' },
        { code: 'nl', name: 'Dutch' },
        { code: 'en', name: 'English' },
        { code: 'en-gb', name: 'English (UK)' },
        { code: 'en-us', name: 'English (US)' },
        { code: 'et', name: 'Estonian' },
        { code: 'fil', name: 'Filipino' },
        { code: 'fi', name: 'Finnish' },
        { code: 'fr', name: 'French' },
        { code: 'ka', name: 'Georgian' },
        { code: 'de', name: 'German' },
        { code: 'el', name: 'Greek' },
        { code: 'gu', name: 'Gujarati' },
        { code: 'ha', name: 'Hausa' },
        { code: 'he', name: 'Hebrew' },
        { code: 'hi', name: 'Hindi' },
        { code: 'hu', name: 'Hungarian' },
        { code: 'id', name: 'Indonesian' },
        { code: 'ga', name: 'Irish' },
        { code: 'it', name: 'Italian' },
        { code: 'ja', name: 'Japanese' },
        { code: 'kn', name: 'Kannada' },
        { code: 'kr', name: 'Kanuri' },
        { code: 'kk', name: 'Kazakh' },
        { code: 'rw', name: 'Kinyarwanda' },
        { code: 'ko', name: 'Korean' },
        { code: 'ky', name: 'Kyrgyz (Kyrgyzstan)' },
        { code: 'lo', name: 'Lao' },
        { code: 'lv', name: 'Latvian' },
        { code: 'lt', name: 'Lithuanian' },
        { code: 'mk', name: 'Macedonian' },
        { code: 'ml', name: 'Malayalam' },
        { code: 'ms', name: 'Malay' },
        { code: 'mr', name: 'Marathi' },
        { code: 'no', name: 'Norwegian' },
        { code: 'fa', name: 'Persian' },
        { code: 'pl', name: 'Polish' },
        { code: 'pt-br', name: 'Portuguese' },
        { code: 'pt', name: 'Portuguese' },
        { code: 'pa', name: 'Punjabi' },
        { code: 'ro', name: 'Romanian' },
        { code: 'ru', name: 'Russian' },
        { code: 'sr', name: 'Serbian' },
        { code: 'sk', name: 'Slovak' },
        { code: 'sl', name: 'Slovenian' },
        { code: 'es', name: 'Spanish' },
        { code: 'es-ar', name: 'Spanish (ARG)' },
        { code: 'es', name: 'Spanish (SPA)' },
        { code: 'es-mx', name: 'Spanish (MEX)' },
        { code: 'sw', name: 'Swahili' },
        { code: 'sv', name: 'Swedish' },
        { code: 'ta', name: 'Tamil' },
        { code: 'te', name: 'Telugu' },
        { code: 'th', name: 'Thai' },
        { code: 'tr', name: 'Turkish' },
        { code: 'uk', name: 'Ukrainian' },
        { code: 'ur', name: 'Urdu' },
        { code: 'uz', name: 'Uzbek' },
        { code: 'vi', name: 'Vietnamese' },
        { code: 'zu', name: 'Zulu' },
      ]
    },
    getLanguageNameFromCode: function (code) {
      const language = this.getLanguages().find(l => l.code === code)
      if (language !== undefined) {
        return language.name
      }
      return ''
    }
  }
}
